<template>
  <div>
    <div class="flex-between">
      <div class="font-size-12 color-complementary-300 flex-start">
        {{ $lang.roomName }}: {{ item.name }}
        <span class="color-complementary-100 padding-x-4"> | </span>
        {{ $lang.roomNumber }}: {{ item.roomNumber }}
      </div>
      <div v-if="!isReadonly" class="flex-end color-complementary-200">
        <span
          v-if="item.link"
          class="margin-left-8 cursor--pointer"
          v-b-tooltip.hover
          :title="$lang.roomLink"
          @click="goToRoom(item.link)"
        >
          <mdicon name="link-variant" size="24" />
        </span>
        <span @click="handleOpenEditPin" class="margin-left-8 cursor--pointer">
          <mdicon
            v-if="checkPermission(permissions, ['admin', 'edit'])"
            name="pencil-outline"
            size="24"
          />
          <mdicon v-else name="eye-outline" size="24" />
        </span>
      </div>
    </div>
    <EditRoomPin
      :visible="isEditPin"
      :roomId="item.id"
      @handleClose="handleCloseEditPin"
    />
  </div>
</template>

<script>
import EditRoomPin from "./EditRoomPin.vue";
import { inject, ref, toRefs } from "vue";
import { checkPermission } from "@/shared/utils";
export default {
  components: { EditRoomPin },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // bind props
    const { item } = toRefs(props);

    // bind inject data
    const permissions = inject("PERMISSIONS");
    const isReadonly = inject("IS_READONLY");

    // handle go to link
    const goToRoom = (link) => {
      if (!link) return;
      window.open(link, "_blank");
    };

    // handle edit item
    const isEditPin = ref(false);
    const handleOpenEditPin = () => (isEditPin.value = true);
    const handleCloseEditPin = () => (isEditPin.value = false);

    // return data to be used in template
    return {
      item,
      permissions,
      checkPermission,
      goToRoom,
      isEditPin,
      handleOpenEditPin,
      handleCloseEditPin,
      isReadonly,
    };
  },
};
</script>
